export function SendBatchBar({ draftCount, selectedCount, disabled, onSend }: { draftCount: number; selectedCount: number; disabled: boolean; onSend: () => void }) {
  return (
    <div className="sticky bottom-0 flex items-center justify-between gap-3 rounded-[10px] border border-border bg-card p-3" data-testid="send-open-item-batch-bar">
      <span className="text-sm">{selectedCount > 0 ? `${selectedCount} selected` : `${draftCount} drafts`}</span>
      <button type="button" className="min-h-11 rounded-md bg-foreground px-4 text-sm font-semibold text-background" disabled={disabled || selectedCount === 0} onClick={onSend}>
        {disabled ? 'Sending…' : `Send batch · ${draftCount} drafts`}
      </button>
    </div>
  );
}

